/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const User = ({
    title,
    titleId,
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        viewBox="0 0 19 23"
        aria-labelledby={titleId}
        height="1em"
        width="1em"
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <g
            fill="none"
            fillRule="evenodd"
            stroke="#FFF"
            strokeLinejoin="round"
            transform="translate(1 1)"
        >
            <path d="M17 17.985C17 13.3 13.194 9.5 8.5 9.5S0 13.299 0 17.985c0 4.687 17 4.687 17 0z" />
            <circle cx={8.5} cy={4.5} r={4.5} />
        </g>
    </svg>
);

export default User;
